import SpatnavContainer from '../lib/SpatnavContainer.js';
import getDeviceType from '../lib/getDeviceType.js';

export default {
    dependencies: [
        '$element',
        '$controllerator',
        'radio',
        'searchmanager',
        'templateservice',
    ],
    callable(element, controllerator, radio, searchmanager, templateservice) {
        window.addEventListener('popstate', handlePopState);
        let hasPaged = false;
        history.replaceState(
            { mustReload: true },
            document.title,
            window.location.href
        );

        const spinner = document.createElement('div');
        spinner.className = 'spinner';

        element.addEventListener('click', _handleAnchorClick);

        // eslint-disable-next-line no-new
        new SpatnavContainer(element, '[data-search-resultitem]', {
            down: 'j',
            up: 'k',
        });

        const isMobile = getDeviceType() === 'mobile';

        const mq = window.matchMedia('(min-width: 768px)');
        mq.addListener(event => {
            if (event.matches) {
                loadLazyImages();
            }
        });

        if (mq.matches) {
            loadLazyImages();
        }

        radio('searchFilter.changed').subscribe(handleFilterMessage);
        radio('searchUrl.updated').subscribe(updateSearchUrl);
        radio('sort-changed').subscribe(handleSortMessage);
        radio('geoSlider.searched').subscribe(() => {
            const noScroll = true;
            hideContent(noScroll);
        });
        radio('geo-sort-initiated').subscribe(() => {
            const noScroll = true;
            hideContent(noScroll);
        });
        radio('searchFilter.notChanged').subscribe(showContent);
        radio('geo-sort-failed').subscribe(showContent);

        function _handleAnchorClick(evt) {
            const ele = evt.target.closest('a[href]');
            if (!ele) {
                return;
            }

            const handled = _handlePagingClick(ele);
            if (handled) {
                evt.preventDefault();
                return;
            }

            // If we clicked on a link to an object, replace the state to avoid
            // reloading (in Safari) when going back the result page.
            history.replaceState(null, null);
        }

        function _handlePagingClick(ele) {
            if (!ele.closest('[data-paging]')) {
                return false;
            }

            const url = new URL(ele.href);
            const index = Number(url.searchParams.get('page')) || 1;
            hideContent();
            promoteNavStateToPage();
            hasPaged = true;
            searchmanager
                .setPage(index)
                .then(onSearchSuccess, onSearchError)
                .then(focusFirstLink);
            updateSearchUrl();
            return true;
        }

        let searchActionsCount = 0;
        const MAX_RELOADS = 20;
        const browserThatRequiresReload = /Edge\/|Trident\/|MSIE /.test(
            window.navigator.userAgent
        );
        let timer;
        function fixIEMemoryIframeLeak() {
            clearTimeout(timer);
            // This can be removed in the future depending on how banners/iframes are served.
            // Avoiding multiple updates generating a searchActionCount, as banners use some time to load
            timer = setTimeout(() => {
                if (browserThatRequiresReload) {
                    searchActionsCount++;
                    if (searchActionsCount >= MAX_RELOADS) {
                        window.location.reload();
                    }
                }
            }, 500);
        }

        function updateSearchUrl() {
            history.replaceState(
                { mustReload: true },
                null,
                searchmanager.searchUrl.replace('.json', '.html')
            );
        }

        function promoteNavStateToPage() {
            history.pushState(
                window.history.state,
                document.title,
                window.location.href
            );
        }

        function renderResult(result) {
            // fixme: runeh: this is temporary, while waiting for partials. Should have a partial
            // for only the search result.
            element.innerHTML = templateservice.render(
                'search_result_items',
                result
            );
            loadLazyImages();
            controllerator.run();
            showContent();
        }

        function handlePopState(evt) {
            if (evt.state && evt.state.mustReload) {
                window.location.reload();
            }
        }

        function handleFilterMessage(filters) {
            hideContent(!isMobile);
            if (hasPaged) {
                hasPaged = false;
                promoteNavStateToPage();
            }
            searchmanager
                .search(filters, 1)
                .then(onSearchSuccess, onSearchError);
            updateSearchUrl();
        }

        function onSearchError() {
            element.innerHTML = templateservice.render('search_result_items', {
                searchError: true,
            });
        }

        function handleSortMessage(sortBy) {
            hideContent(!isMobile);
            if (hasPaged) {
                hasPaged = false;
                promoteNavStateToPage();
            }
            searchmanager.sort(sortBy).then(onSearchSuccess);
            updateSearchUrl();
        }

        function onSearchSuccess(result) {
            if (!result) {
                return;
            }
            radio('pre-filter-and-search-changed').broadcast(result);
            renderResult(result);
            fixIEMemoryIframeLeak();
            radio('filter-and-search-changed').broadcast(result);
            document.title = result.subTitle;
        }

        function hideContent(noScroll) {
            element.querySelector('.bd').style.opacity = 0.3;
            if (!noScroll) {
                document.documentElement.scrollTop = document.body.scrollTop = 0; // Some browsers // Other browsers
            }
        }

        function showContent() {
            element.querySelector('.bd').style.opacity = 1;
        }

        function focusFirstLink() {
            const firstLink = element.querySelector('a');
            if (firstLink) {
                firstLink.focus();
            }
        }

        function loadLazyImages() {
            const lazyImgEles = element.querySelectorAll('img[data-src]');
            Array.from(lazyImgEles).forEach(ele => {
                ele.src = ele.getAttribute('data-src');
                ele.removeAttribute('data-src');
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/searchResult.js